import { Component, ChangeDetectorRef } from '@angular/core';
import { Network } from '@ionic-native/network';

@Component({
  selector: 'disconnect-network',
  templateUrl: 'disconnect.html'
})
export class DisconnectComponent {

  display: boolean = false;

  constructor(private network: Network, private cdRef: ChangeDetectorRef) {
    this.subscribe();
  }

  subscribe(){
    this.network.onDisconnect().subscribe(() => {
      this.display  = true;
      this.detectChanges();
    });

    this.network.onConnect().subscribe(() => {
      this.display  = false;
      this.detectChanges();
    });
  }

  detectChanges(){
    setTimeout(() => this.cdRef.detectChanges(), 1000);
  }

  isConnect() {
    if(this.network.type != 'none') {
      this.display  = false;
      this.detectChanges();
    }
  }

  cerrar() {
    this.display = false;
    this.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/components/disconnect/disconnect.ts